import type { Model } from "../types";

/* v3 ignores similarity/style/speed and only takes 3 stability steps - the
   settings card reads the same flag, so the two cards can't disagree. */
export const V3_MODELS = new Set(["eleven_v3"]);
export const V3_STABILITY_STEPS = [0, 0.5, 1];

export const isV3 = (modelId: string): boolean => V3_MODELS.has(modelId);

export function snapStability(value: number): number {
  return V3_STABILITY_STEPS.reduce(
    (best, step) => (Math.abs(step - value) < Math.abs(best - value) ? step : best),
    0.5,
  );
}

interface Props {
  models: Model[];
  modelId: string;
  onChange: (modelId: string) => void;
}

/* The composer's `model` chip. Not a card any more: the model gets picked once
   a session, and it was holding a permanent slot in the sidebar for it. */
export function ModelPicker({ models, modelId, onChange }: Props) {
  const model = models.find((candidate) => candidate.model_id === modelId);
  const notes: string[] = [];
  if (model) {
    if (model.description) notes.push(model.description);
    if (model.cost_factor && model.cost_factor !== 1) {
      notes.push(`${model.cost_factor}× credit cost`);
    }
    if (model.languages?.length) notes.push(`${model.languages.length} languages`);
  }
  if (isV3(modelId)) {
    notes.push(
      "Supports audio tags like [laughs].",
    );
  }

  return (
    <div className="picker model-picker">
      <div className="picker-head">
        <span className="field-label">Model</span>
      </div>
      <select value={modelId} onChange={(event) => onChange(event.target.value)}>
        {models.map((candidate) => (
          <option key={candidate.model_id} value={candidate.model_id}>
            {candidate.name || candidate.model_id}
          </option>
        ))}
      </select>
      <div className="hint" style={{ marginTop: 8 }}>
        {notes.join(" · ")}
      </div>
    </div>
  );
}
